module.exports = __webpack_public_path__ + "static/media/logotipo_transparente_fundoclaro.691c116c.png";